import { useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";
import axios from '../../config/axiosInstance';
import axiosWithoutInterceptor from 'axios';
import { usageLog } from '../../store/actions/globalActions';

const PremiumPaymentViewModel = () => {

    useEffect(() => {
        urlplan()
        setOriginPath(document.referrer)

        const currentUrl = window.location.href;

        // Cria um objeto URL a partir da URL da página
        const url = new URL(currentUrl);
        const indicatorUserId = parseFloat(url.searchParams.get("IndicatorUserId"));
        if (indicatorUserId) {
            // const company = JSON.parse(localStorage.getItem('companies')).find(Id => Id.companyId);
            usageLog(`laCasaSinPapel/link_cadastro/dashboard/cadastro`,null,indicatorUserId)
        }

    }, [])



    const isSmallScreen = useMediaQuery('(max-width:1278px)');
    const [activeStep, setActiveStep] = useState(0);
    const [sliderValue, setSliderValue] = useState(50);
    const buttonText = isSmallScreen ? 'Boleto' : 'Quero pagar no boleto';
    const [steps] = useState(['Crie sua conta', 'Cadastre sua empresa']);
    const [selectedPlan, setSelectedPlan] = useState("corporate");
    const [paymentType, setPaymentType] = useState('mensal');

    const [personData, setPersonData] = useState({})
    const [companyData, setCompanyData] = useState({})
    const [planData, setPlanData] = useState({})
    const [activeErrorPassword, setActiveErrorPassword] = useState(false)
    const [errorPassword, setErrorPassword] = useState('')
    const [activeValidEmail, setActiveValidEmail] = useState(false)
    const [validEmail, setValidEmail] = useState('')
    const [errorGeneric, setErrorGeneric] = useState('')
    const [activeErrorCNJ, setActiveErrorCNJ] = useState(false)
    const [errorCNJ, setErrorCNJ] = useState('')
    const [originPath, setOriginPath] = useState('')

    const [plan, setPlan] = useState([
        {
            config: {
                name: 'corporate',
                monthlyValue: '499',
                yearlyValue: '416',
                fullValue: '4.999',
                discount: '16%'
            }
        },
        {
            config: {
                name: 'enterprise',
                monthlyValue: '159',
                yearlyValue: '119',
                fullValue: '1.438',
                discount: '25%'
            }
        },
        {
            config: {
                name: 'premium',
                monthlyValue: '89',
                yearlyValue: '69',
                fullValue: '838',
                discount: '22%'
            }
        },
        {
            config: {
                name: 'light',
                monthlyValue: '1',
                yearlyValue: '1',
                fullValue: '1',
                discount: '1%'
            }
        },
    ])

    const [formValues, setFormValues] = useState([
        {
            config: {
                id: 'firstName',
                name: 'firstName',
                label: 'Nome',
                mask: '',
                type: '',
                value: ''
            }
        },
        {
            config: {
                id: 'lastName',
                name: 'lastName',
                label: 'Sobrenome',
                mask: '',
                type: '',
                value: ''
            }
        },
        {
            config: {
                id: 'email',
                name: 'email',
                label: 'Email',
                mask: '',
                type: 'email',
                value: ''
            }
        },
        {
            config: {
                id: 'phone',
                name: 'phone',
                label: 'Celular',
                mask: '(99) 99999-9999',
                type: '',
                value: ''
            }
        },
        {
            config: {
                id: 'password',
                name: 'password',
                label: 'Senha',
                mask: '',
                type: 'password',
                value: ''
            }
        },
        {
            config: {
                id: 'passwordConfirm',
                name: 'passwordConfirm',
                label: 'Confirmar Senha',
                mask: '',
                type: 'password',
                value: ''
            }
        }
    ]);

    const [employeer, setEmployeer] = useState([
        {
            config: {
                id: 'cnpj',
                name: 'cnpj',
                label: 'CNPJ',
                mask: '99.999.999/9999-99',
                type: '',
                value: ''
            }
        },
        {
            config: {
                id: 'fantasyName',
                name: 'fantasyName',
                label: 'Nome fantasia',
                mask: '',
                type: '',
                value: ''
            }
        },
        {
            config: {
                id: 'corporateName',
                name: 'corporateName',
                label: 'Razão social',
                mask: '',
                type: '',
                value: ''
            }
        }
    ]);

    const [addressEmployeer, setAddressEmployeer] = useState([
        {
            config: {
                id: 'cep',
                name: 'cep',
                label: 'CEP',
                mask: '99999-999',
                type: '',
                value: ''
            }
        },
        {
            config: {
                id: 'address',
                name: 'address',
                label: 'Endereço',
                mask: '',
                type: '',
                value: ''
            }
        },
        {
            config: {
                id: 'number',
                name: 'number',
                label: 'Número',
                mask: '',
                type: '',
                value: ''
            }
        },
        {
            config: {
                id: 'district',
                name: 'district',
                label: 'Bairro',
                mask: '',
                type: '',
                value: ''
            }
        },
        {
            config: {
                id: 'city',
                name: 'city',
                label: 'Cidade',
                mask: '',
                type: '',
                value: ''
            }
        },
        {
            config: {
                id: 'complement',
                name: 'complement',
                label: 'Complemento',
                mask: '',
                type: '',
                value: ''
            }
        },
    ]);

    const marks = [
        {
            value: 1,
            label: '1',
        },
        {
            value: 500,
            label: '500+',
        }
    ];

    function urlplan() {
        const url = new URL(window.location.href);
        const planUrl = url.searchParams.get("plan");
        const pagamentoUrl = url.searchParams.get("Anual");

        if (planUrl) {
            setSelectedPlan(planUrl)
        }
        if (pagamentoUrl) {
            setPaymentType(pagamentoUrl == 'true' ? 'anual' : 'mensal')
        }
    };

    const currentUrl = window.location.href;

    // Cria um objeto URL a partir da URL da página
    const url = new URL(currentUrl);
    const indicatorUserId = parseFloat(url.searchParams.get("IndicatorUserId"));

    function creatingAccount() {
        try {
            setErrorGeneric('')
            const data = {
                accountable: personData?.firstName,
                cnpj: companyData?.cnpj.replace(/\D/g, ''),
                socialName: companyData?.fantasyName,
                businessName: companyData?.corporateName,
                companyName: companyData?.fantasyName,
                employeesRange: sliderValue?.toString() || companyData?.employeesRange?.toString(),
                intermedium: 'NEW PREMIUM PAYMENT SCREEN',
                mail: personData?.email,
                originPath: originPath || 'NEW PREMIUM PAYMENT SCREEN',
                password: personData?.password,
                phone: personData?.phone.replace(/\D/g, ''),
                selectedPlan: planData?.Plano || selectedPlan,
                terms: true,
                address: companyData?.address,
                district: companyData?.district,
                cityCod: companyData?.ibge, //codigo da cidade
                stateCod: companyData?.state,
                complement: companyData?.complement,
                cep: companyData?.cep.replace(/\D/g, ''),
                indicatorUserId: indicatorUserId ? indicatorUserId : null
            };
            // console.log('data', data)
            // nextStepper();
            axios.post('/registerCompany', data)
                .then(response => {
                    nextStepper();
                    // window.gtag('event', 'conversion', { send_to: 'AW-767300505/68IHCM3vrM4BEJmn8O0C' });
                    // console.log(response.data);
                    usageLog("criar_empresa/dashboard/cadastro/sucesso",response.data.companies[0].companyId,response.data.companies[0].userId)
                })
                .catch(error => {
                    if (error == 'O e-mail informado já está cadastrado. Utilize a página de login para acessar sua empresa ou entre em contato com o nosso suporte.') {
                        setErrorGeneric(error)
                        backStepper()
                    } else if (error == 'Esse cnpj já está cadastrado. Utilize a página de login para acessar sua empresa ou entre em contato com o suporte!') {
                        setErrorGeneric(error)
                    }
                    console.error(error);
                });
        } catch (error) {
            console.log(error)
        }
    }

    function nextStepper() {
        if (isFormValid() && !activeErrorPassword) {
            setActiveStep(prevState => prevState + 1);
            const userData = {
                name :personData?.firstName,
                email: personData?.email,
                phone: personData?.phone.replace(/\D/g, '')
            }
            usageLog("criar_empresa/dashboard/cadastro/continuar",null,null,userData)
        } else {
            // console.log('Preencha todos os campos!')
        }
    }

    function backStepper() {
        setActiveStep(prevState => prevState - 1)
    }

    const handlePaymentTypeChange = (event) => {
        const { name, value } = event.target;
        setPaymentType(event.target.value);
        setPlanData(prevState => ({ ...prevState, [name]: value }));
    }

    const handleChangeAccount = (event) => {
        const { name, value } = event.target;
        setFormValues(prevState => prevState.map(item => item.config.name === name ? { ...item, config: { ...item.config, value } } : item));
        setPersonData(prevState => ({ ...prevState, [name]: value }));
    };

    const handleChangeEmployeer = (event) => {
        const { name, value } = event.target;
        setEmployeer(prevState => prevState.map(item => item.config.name === name ? { ...item, config: { ...item.config, value } } : item));
        setCompanyData(prevState => ({ ...prevState, [name]: value }));
    };

    const handleChangeSlider = (event, newValue) => {
        const { name, value } = event.target;
        setSliderValue(newValue);
        setCompanyData(prevState => ({ ...prevState, [name]: value }));
    };

    const handleChangeAddress = (event) => {
        const { name, value } = event.target;

        setAddressEmployeer((prevState) =>
            prevState.map((item) =>
                item.config?.name === name ? { ...item, config: { ...item.config, value } } : item
            )
        );

        setCompanyData((prevState) => ({
            ...prevState,
            [name]: value,
            ...(name === "cep" &&
                value.length === 8 && {
                address: "",
                district: "",
                city: "",
                state: "",
                ibge: "",
            }),
        }));

        if (name === "cep" && value.replace(/\D/g, "").length === 8) {
            const fullCEP = value.replace(/\D/g, "");

            axiosWithoutInterceptor
                .get(`https://viacep.com.br/ws/${fullCEP}/json/`)
                .then((response) => {
                    const { logradouro, bairro, localidade, uf, ibge } = response.data;

                    setAddressEmployeer((prevState) =>
                        prevState.map((item) =>
                            item.config.name === "address"
                                ? { ...item, config: { ...item.config, value: logradouro } }
                                : item.config.name === "district"
                                    ? { ...item, config: { ...item.config, value: bairro } }
                                    : item.config.name === "city"
                                        ? { ...item, config: { ...item.config, value: localidade } }
                                        : item.config.name === "state"
                                            ? { ...item, config: { ...item.config, value: uf } }
                                            : item
                        )
                    );

                    setCompanyData((prevState) => ({
                        ...prevState,
                        address: logradouro,
                        district: bairro,
                        city: localidade,
                        state: uf,
                        ibge: ibge,
                    }));
                })
                .catch((error) => console.log(error));
        }
    };

    const handleChangePlan = (event) => {
        const { name, value } = event.target;
        setSelectedPlan(event.target.value);
        setPlanData(prevState => ({ ...prevState, [name]: value }));
    };

    function isFormValid() {
        for (const item of formValues) {
            if (!item.config.value) {
                return false;
            }
        }
        return true;
    }

    const isValidCNPJ = (cnpj) => {
        const cnpjRegex = /^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/;
        if (!cnpjRegex.test(cnpj)) return false;

        const digits = cnpj.replace(/\D/g, '');
        const firstVerifier = calcVerifierDigit(digits.slice(0, 12), 5);
        const secondVerifier = calcVerifierDigit(digits.slice(0, 12) + firstVerifier, 6);
        return digits.slice(-2) === firstVerifier + secondVerifier;
    }

    const calcVerifierDigit = (digits, start) => {
        let sum = 0;
        for (let i = 0; i < digits.length; i++) {
            sum += digits[i] * start--;
            if (start < 2) start = 9;
        }
        const verifierDigit = 11 - (sum % 11);
        return verifierDigit > 9 ? '0' : String(verifierDigit);
    };

    const password = formValues.find(item => item.config.name === 'password')?.config?.value;

    const passwordConfirm = formValues.find(item => item.config.name === 'passwordConfirm')?.config?.value;

    const differentPasswords = password == passwordConfirm;

    const disabledFormValues = formValues.some(item => item.config.value == '' || !differentPasswords);

    function validateErrosPassword() {
        if (!differentPasswords) {
            setActiveErrorPassword(true)
            setErrorPassword("Os campos senha e confirmar senha não correspondem, digite a mesma senha nos campos!")
        } else {
            setActiveErrorPassword(false)
            setErrorPassword('')
        }
    }

    const validarEmail = (value) => {
        var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        // Verificar se o email corresponde à expressão regular
        if (!regex.test(value)) {
            setActiveValidEmail(true)
            setValidEmail("O email inserido não é válido. Por favor, verifique e tente novamente.")
        } else {
            setActiveValidEmail(false)
            setValidEmail('')
        }
    }

    const disabledEmployeerAddress = addressEmployeer.some(item => item.config.name !== 'number' && item.config.name !== 'complement' && item.config.value === '');

    const disabledEmployeer = employeer.some(item => {
        const value = item.config.value;
        if (!value) return true; // campo vazio
        if (item.config.name === 'cnpj' && !isValidCNPJ(value)) return true; // CNPJ inválido
        return false;
    });

    //Precisa melhorar essa logica duplicada.
    useEffect(() => {
        const disabledEmployeer = employeer.some(item => {
            const value = item.config.value;
            if (!value) return true; // campo vazio
            if (item.config.name === 'cnpj') {
                // console.log(item.config.value.replace(/[^\d]+/g, '').length)
                if (item.config.value.replace(/[^\d]+/g, '').length >= 14) {
                    const isValid = isValidCNPJ(value);
                    setActiveErrorCNJ(!isValid); // Define o estado do erro
                    setErrorCNJ(!isValid ? "CNPJ inválido. Por favor, insira um CNPJ válido." : '');
                    setErrorGeneric('')
                    return !isValid; // Retorna true se o CNPJ for inválido
                }
            }
            return false;
        });
        // ...
    }, [employeer]);

    const [disabledButtonEmail, setDisabledButtonEmail] = useState(false);

    useEffect(() => {
        if (personData?.email) {
            setDisabledButtonEmail(validateEmail(personData?.email) == false ? true : false)
        }
    }, [personData])

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };


    const disabledButton = (activeStep === 0 && disabledFormValues) || (activeStep === 1 && (disabledEmployeerAddress || disabledEmployeer) || disabledButtonEmail);

    return {
        buttonText,
        activeStep,
        setActiveStep,
        steps,
        nextStepper,
        backStepper,
        paymentType,
        handlePaymentTypeChange,
        creatingAccount,
        setPersonData,
        personData,
        setCompanyData,
        handleChangeAccount,
        formValues,
        disabledButton,
        sliderValue,
        employeer,
        addressEmployeer,
        marks,
        handleChangeEmployeer,
        handleChangeAddress,
        handleChangeSlider,
        plan,
        selectedPlan,
        planData,
        handleChangePlan,
        activeErrorPassword,
        errorPassword,
        validateErrosPassword,
        activeValidEmail,
        validEmail,
        validarEmail,
        activeErrorCNJ,
        errorCNJ,
        errorGeneric
    }
}

export default PremiumPaymentViewModel;